'use client';

import { useMemo, memo } from 'react';

import Link from 'next/link';

import { LuArrowRightToLine } from 'react-icons/lu';

import { useAuthStore } from '@/stores/userStore';
import DecorativeCard from '@/stories/molecules/cards/decorativeCard/DecorativeCard';

import core from './localization/core';

const Bonus = memo(() => {
  const spins = useAuthStore((state) => { return state.bonuses?.spins ?? []; });

  const hasBonuses = useMemo(() => {
    return spins.length > 0;
  }, [spins.length]);

  if (!hasBonuses) return null;

  return (
    <DecorativeCard
      content={(
        <div>
          <h3 className="text-hforeground font-title text-base md:text-lg font-black">{core.bonus.title}</h3>
          <p className="text-hforeground mt-2 font-text text-sm leading-none w-3/5 md:leading-tight">{core.bonus.description}</p>
          <Link
            href={core.bonus.link}
            className="flex items-center bg-linear-to-t from-hgradient-50 to-hgradient-100 text-transparent bg-clip-text font-text text-xs md:text-base mt-2"
            aria-label={`${core.bonus.textLink} sobre ${core.bonus.title}`}
          >
            <span className="bg-linear-to-t from-hgradient-50 to-hgradient-100 text-transparent bg-clip-text">
              {core.bonus.textLink}
            </span>
            <LuArrowRightToLine className="ml-2 text-hgradient-100" />
          </Link>
        </div>
      )}
      img={core.bonus.img}
      imgRotate="none"
    />
  );
});

export default Bonus;
